/**
 * @typedef SRConfig
 * @property {string} siteUrl
 * @property {string} brandNameFull
 * @property {string} logoVersion
 * @property {string} urlPrefix
 * @property {string} apiPrefix
 */

/**
 * @param {SRConfig} config
 * @returns {string}
 */
export var getSubscriptionAccountUrl = function getSubscriptionAccountUrl(config) {
  return "https://" + config.apiPrefix + "subscriptionservice." + config.siteUrl + "/api/account";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getSubscriptionUrl = function getSubscriptionUrl(config) {
  return "https://" + config.apiPrefix + "subscriptionservice." + config.siteUrl + "/api/subscription";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getServiceUrl = function getServiceUrl(config) {
  return "https://" + config.apiPrefix + "klantenservice." + config.siteUrl + "/?chat=1";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getPlusFaqUrl = function getPlusFaqUrl(config) {
  return "https://klantenservice." + config.siteUrl + "/plus";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getAuthUrl = function getAuthUrl(config) {
  return "https://" + config.apiPrefix + "auth." + config.siteUrl + "/authentication";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getMultiBrandActivationUrl = function getMultiBrandActivationUrl(config) {
  return "https://" + config.apiPrefix + "multiaccessservice." + config.siteUrl + "/api/multiAccessLinking";
};
/**
 * @param {SRConfig} config
 * @returns {string}
 */

export var getAccountManagementUrl = function getAccountManagementUrl(config) {
  return "https://" + config.apiPrefix + "accountmanagement." + config.siteUrl + "/api/v1.1";
};
export var getChatbotRobbieBaseUrl = function getChatbotRobbieBaseUrl() {
  return MH_ENV === 'production' ? 'https://chatbotgvaprdsa.blob.core.windows.net/bot-resources' : 'https://medhtstpvabotsa.blob.core.windows.net/bot-resources';
};